import { useQuery } from '@tanstack/react-query';
import { schedulingApi } from '@/api';

const SLOTS_KEY = (doctorId: string, date: string) => ['doctor', doctorId, 'slots', date] as const;

async function fetchAvailableSlots(doctorId: string, date: string) {
  return schedulingApi.getAvailableSlots(doctorId, date);
}

export function useAvailableSlots(doctorId: string, date: string) {
  return useQuery({
    queryKey: SLOTS_KEY(doctorId, date),
    queryFn: () => fetchAvailableSlots(doctorId, date),
    enabled: !!doctorId && !!date,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}
